import * as actions from './actions';

export default {
  jackpot_win: actions.addWinner,
}